import CitizenUserDropboxMenu from './CitizenUserDropboxMenu';
import React, { useEffect, useState } from 'react';
import { ArrowCircleUpIcon } from '@heroicons/react/outline';
import BusinessDropboxMenu from './BusinessDropboxMenu';

const NewTransferPopupBody = ({
  database,
  user,
  setWesters,
  westers,
  getTime,
  getDate,
  getYear,
  setTransfers,
  setNewTransferPopupOpen,
}) => {
  const [citizens, setCitizens] = useState([]);
  const [filteredCitizens, setFilteredCitizens] = useState([]);
  const [selectedCitizen, setSelectedCitizen] = useState();
  const [businesses, setBusinesses] = useState([]);
  const [filteredBusinesses, setFilteredBusinesses] = useState([]);
  const [selectedBusiness, setSelectedBusiness] = useState();
  const [transferAmount, setTransferAmount] = useState(0);
  const [transferReason, setTransferReason] = useState('');
  const [salesTaxRate, setSalesTaxRate] = useState(0);
  const charlingtonEpoch = 1766275200000;

  useEffect(() => {
    addCitizens();
    addBusinesses();
    console.log('Called useeffect');
  }, []);
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  function addCitizens() {
    database
      .ref('/citizens')
      .get()
      .then((citizensObjects) => {
        setCitizens(
          Object.values(citizensObjects.val()).sort((cit1, cit2) =>
            cit1.name.localeCompare(cit2.name),
          ),
        );
        setFilteredCitizens(
          Object.values(citizensObjects.val()).sort((cit1, cit2) =>
            cit1.name.localeCompare(cit2.name),
          ),
        );
        //setSelectedCitizen(Object.values(citizensObjects.val())[0]);
      });
  }

  function addBusinesses() {
    database
      .ref('/businesses')
      .get()
      .then((businessesObjects) => {
        setBusinesses(
          Object.values(businessesObjects.val()).sort((bus1, bus2) =>
            bus1.name.localeCompare(bus2.name),
          ),
        );
        setFilteredBusinesses(
          Object.values(businessesObjects.val()).sort((bus1, bus2) =>
            bus1.name.localeCompare(bus2.name),
          ),
        );
        database
          .ref('/government/salesTaxRate')
          .get()
          .then((salesTaxRateSnapshot) => {
            setSalesTaxRate(salesTaxRateSnapshot.val());
          });
      });
  }

  function onClickSendTransfer() {
    var receiverResultingBalance = 0;
    var senderResultingBalance = 0;
    if (isTransferAmountValid()) {
      if (selectedCitizen != undefined) {
        database
          .ref(`/citizens/${selectedCitizen.citizenID}/westers`)
          .get()
          .then((westersSnapshot) => {
            const amountTaxed = Math.round(
              Number(transferAmount) * salesTaxRate,
            );
            receiverResultingBalance = Number(
              (
                Number(westersSnapshot.val()) +
                Number(transferAmount) -
                amountTaxed
              ).toFixed(2),
            );
            database
              .ref(`/citizens/${selectedCitizen.citizenID}/westers`)
              .set(receiverResultingBalance);
            database
              .ref(`/citizens/${user.citizenID}/westers`)
              .get()
              .then((westersSnapshot) => {
                senderResultingBalance = Number(
                  (
                    Number(westersSnapshot.val()) - Number(transferAmount)
                  ).toFixed(2),
                );
                database
                  .ref(`/citizens/${user.citizenID}/westers`)
                  .set(senderResultingBalance);
                user.westers = senderResultingBalance;
                const transferID = generateTransferID();
                database
                  .ref(`/citizens/${user.citizenID}/transfers/${transferID}`)
                  .set({
                    transferID: transferID,
                    date: `${getDate()}, ${getYear()}`,
                    time: getTime(),
                    mssce: Math.round(new Date().getTime() - charlingtonEpoch),
                    amount: Number(transferAmount.toFixed(2)),
                    receiverID: selectedCitizen.citizenID,
                    receiverName: selectedCitizen.name,
                    type: 'Outgoing',
                    reason:
                      transferReason.length != 0
                        ? transferReason
                        : 'None given',
                    resultingBalance: senderResultingBalance,
                  });
                database
                  .ref(
                    `/citizens/${selectedCitizen.citizenID}/transfers/${transferID}`,
                  )
                  .set({
                    transferID: transferID,
                    date: `${getDate()}, ${getYear()}`,
                    time: getTime(),
                    mssce: Math.round(new Date().getTime() - charlingtonEpoch),
                    amount: Number((transferAmount - amountTaxed).toFixed(2)),
                    senderID: user.citizenID,
                    senderName: user.name,
                    type: 'Incoming',
                    reason:
                      transferReason.length != 0
                        ? transferReason
                        : 'None given',
                    resultingBalance: receiverResultingBalance,
                  });
                if (amountTaxed > 0) {
                  const taxTransferID = generateTransferID();
                  database
                    .ref('/government')
                    .get()
                    .then((governmentSnapshot) => {
                      var governmentFunds = governmentSnapshot.val().westers;
                      const newGovernmentFunds = governmentFunds + amountTaxed;
                      database
                        .ref('/government/westers')
                        .set(newGovernmentFunds);
                      database
                        .ref(`/government/transfers/${taxTransferID}`)
                        .set({
                          transferID: taxTransferID,
                          date: `${getDate()}, ${getYear()}`,
                          time: getTime(),
                          mssce: Math.round(
                            new Date().getTime() - charlingtonEpoch,
                          ),
                          amount: Number(amountTaxed.toFixed(2)),
                          senderID: user.citizenID,
                          senderName: user.name,
                          type: 'Incoming',
                          reason: `${salesTaxRate * 100}% tax of ${transferID}`,
                          resultingBalance: newGovernmentFunds,
                        });
                    });
                }
                database
                  .ref(`/citizens/${user.citizenID}/transfers`)
                  .get()
                  .then((transfersSnapshot) => {
                    console.log('Transfers', transfersSnapshot.val());
                    user.transfers = Object.values(
                      transfersSnapshot.val(),
                    ).sort((transfer1, transfer2) => {
                      return transfer2.mssce - transfer1.mssce;
                    });
                    localStorage.setItem('user', JSON.stringify(user));
                    setNewTransferPopupOpen(false);
                  });
              });
          });
      } else if (selectedBusiness != undefined) {
        database
          .ref(`/businesses/${selectedBusiness.businessID}`)
          .get()
          .then((businessSnapshot) => {
            const business = businessSnapshot.val();

            const editedBusiness = { ...business };

            const amountTaxed = Math.round(
              Number(transferAmount) * salesTaxRate,
            );

            const receiverResultingBalance = Number(
              (
                Number(business.westers) +
                Number(transferAmount) -
                amountTaxed
              ).toFixed(2),
            );

            editedBusiness.westers = receiverResultingBalance;

            const currentValue =
              editedBusiness.westers /
              editedBusiness.stockHistory.filter((stockTrans) => {
                return stockTrans.bought == true;
              }).length;

            let currentPriceIfBought = currentValue + currentValue * 0.05;

            const numberOfSharesIfBought =
              editedBusiness.stockHistory.filter((stockTrans) => {
                return stockTrans.bought == true;
              }).length + 1;

            let newBusinessBalanceIfBought =
              currentPriceIfBought * numberOfSharesIfBought;

            // Make up the difference
            currentPriceIfBought =
              newBusinessBalanceIfBought - editedBusiness.westers;

            editedBusiness.stockHistory.push({
              time: Date.now(),
              price: currentPriceIfBought,
              citizenID: 'SYSTEM',
              citizenName: 'SYSTEM',
              bought: false,
            });
            database
              .ref(`/businesses/${selectedBusiness.businessID}`)
              .set(editedBusiness);
            database
              .ref(`/citizens/${user.citizenID}/westers`)
              .get()
              .then((westersSnapshot) => {
                senderResultingBalance = Number(
                  (
                    Number(westersSnapshot.val()) - Number(transferAmount)
                  ).toFixed(2),
                );
                database
                  .ref(`/citizens/${user.citizenID}/westers`)
                  .set(senderResultingBalance);
                user.westers = senderResultingBalance;
                const transferID = generateTransferID();
                database
                  .ref(`/citizens/${user.citizenID}/transfers/${transferID}`)
                  .set({
                    transferID: transferID,
                    date: `${getDate()}, ${getYear()}`,
                    time: getTime(),
                    mssce: Math.round(new Date().getTime() - charlingtonEpoch),
                    amount: Number(transferAmount.toFixed(2)),
                    receiverID: selectedBusiness.businessID,
                    receiverName: selectedBusiness.name,
                    type: 'Outgoing',
                    reason:
                      transferReason.length != 0
                        ? transferReason
                        : 'None given',
                    resultingBalance: senderResultingBalance,
                  });
                database
                  .ref(
                    `/businesses/${selectedBusiness.businessID}/transfers/${transferID}`,
                  )
                  .set({
                    transferID: transferID,
                    date: `${getDate()}, ${getYear()}`,
                    time: getTime(),
                    mssce: Math.round(new Date().getTime() - charlingtonEpoch),
                    amount: Number((transferAmount - amountTaxed).toFixed(2)),
                    senderID: user.citizenID,
                    senderName: user.name,
                    type: 'Incoming',
                    reason:
                      transferReason.length != 0
                        ? transferReason
                        : 'None given',
                    resultingBalance: receiverResultingBalance,
                  });
                if (amountTaxed > 0) {
                  const taxTransferID = generateTransferID();
                  database
                    .ref('/government')
                    .get()
                    .then((governmentSnapshot) => {
                      var governmentFunds = governmentSnapshot.val().westers;
                      const newGovernmentFunds = governmentFunds + amountTaxed;
                      database
                        .ref('/government/westers')
                        .set(newGovernmentFunds);
                      database
                        .ref(`/government/transfers/${taxTransferID}`)
                        .set({
                          transferID: taxTransferID,
                          date: `${getDate()}, ${getYear()}`,
                          time: getTime(),
                          mssce: Math.round(
                            new Date().getTime() - charlingtonEpoch,
                          ),
                          amount: Number(amountTaxed.toFixed(2)),
                          senderID: user.citizenID,
                          senderName: user.name,
                          type: 'Incoming',
                          reason: `${salesTaxRate * 100}% tax of ${transferID}`,
                          resultingBalance: newGovernmentFunds,
                        });
                    });
                }
                database
                  .ref(`/citizens/${user.citizenID}/transfers`)
                  .get()
                  .then((transfersSnapshot) => {
                    console.log('Transfers', transfersSnapshot.val());
                    user.transfers = Object.values(
                      transfersSnapshot.val(),
                    ).sort((transfer1, transfer2) => {
                      return transfer2.mssce - transfer1.mssce;
                    });
                    localStorage.setItem('user', JSON.stringify(user));
                    setNewTransferPopupOpen(false);
                  });
              });
          });
      }
    }
  }

  function generateTransferID() {
    var transferID = 'MT-';
    for (var i = 0; i < 5; i++) {
      transferID = transferID + String(Math.floor(Math.random() * 10));
    }
    return transferID;
  }

  function isTransferAmountValid() {
    return (
      (selectedCitizen != undefined || selectedBusiness != undefined) &&
      String(transferAmount).length != 0 &&
      !String(transferAmount).startsWith('-') &&
      Number(user.westers) - Number(transferAmount) >= 0 &&
      transferAmount != 0
    );
  }

  return (
    <div className='w-full justify-center '>
      <div className='pb-4'>
        <div className='p-5 bg-sky-800 rounded shadow'>
          <div className=''>
            <div className='w-full pb-2'>
              <p className='text-sm font-bold'>TO</p>
              {selectedBusiness != undefined ? null : (
                <CitizenUserDropboxMenu
                  filteredCitizens={filteredCitizens}
                  setFilteredCitizens={setFilteredCitizens}
                  citizens={citizens}
                  selectedCitizen={selectedCitizen}
                  setSelectedCitizen={setSelectedCitizen}
                  className='pb-2'
                  user={user}
                />
              )}

              {selectedCitizen != undefined ? null : (
                <BusinessDropboxMenu
                  filteredBusinesses={filteredBusinesses}
                  setFilteredBusinesses={setFilteredBusinesses}
                  businesses={businesses}
                  selectedBusiness={selectedBusiness}
                  setSelectedBusiness={setSelectedBusiness}
                  className='pb-2'
                  user={user}
                />
              )}
            </div>
            <div className='w-full pb-2'>
              <p className='text-sm font-bold'>AMOUNT</p>
              <div className='flex w-full justify-center'>
                <p className='font-semibold pr-1 text-xl'>W</p>
                <input
                  type='Number'
                  placeholder=''
                  min={0}
                  max={user.westers}
                  defaultValue={transferAmount}
                  onChange={(event) => {
                    setTransferAmount(Number(event.target.value));
                  }}
                  className='rounded appearance-textfield flex justify-center w-full focus:outline-none border-2 border-gray-500 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 p-1'
                ></input>
              </div>
            </div>
          </div>
          <div className='pb-2'>
            <p className='text-sm font-bold'>REASON</p>
            <div className='flex justify-center'>
              <textarea
                placeholder=''
                onChange={(event) => {
                  setTransferReason(event.target.value);
                }}
                className='rounded w-full bg-white h-20 flex justify-center resize-none focus:outline-none border-2 border-gray-500 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 p-2'
              ></textarea>
            </div>
          </div>
          {isTransferAmountValid() && (
            <div>
              <div className='pb-2'>
                <p className='text-sm font-bold'>RESULTING BALANCE</p>

                <p className='p-1 font-semibold shadow bg-black '>
                  {'W'}
                  {(Number(user.westers) - Number(transferAmount)).toFixed(2)}
                </p>
              </div>
              <div className='pb-2'>
                <p className='text-sm font-bold'>AMOUNT TAXED</p>

                <p className='p-1 font-semibold shadow bg-black '>
                  W
                  {Math.round(
                    Number(transferAmount) * Number(salesTaxRate),
                  ).toFixed(2)}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      <button
        className={classNames(
          isTransferAmountValid()
            ? 'text-black bg-sky-400 hover:bg-sky-500'
            : 'text-gray-400 bg-sky-100',
          'w-1/3 rounded-full px-3 py-2 font-semibold shadow',
        )}
        onClick={onClickSendTransfer}
      >
        <div className='flex justify-center'>
          <ArrowCircleUpIcon className='h-6 w-6' />
          Send
        </div>
      </button>
    </div>
  );
};

export default React.memo(NewTransferPopupBody);
